import moment from 'moment-timezone';
import { ReplyForwardEditorAction, ReplyForwardEmailPreview } from '../../type';

export const getDefaultContentForReplyForwardEditor = (
  action: ReplyForwardEditorAction,
  selectedEmail: ReplyForwardEmailPreview,
  unifiedContent?: string,
) => {
  if (action === 'forward') {
    const date = moment(selectedEmail.sentDate);

    const formattedDate = `${date.format('ddd')}, ${date.format(
      'MMM DD',
    )}, ${date.format('YYYY')}, at ${date.format('hh:mm a').toUpperCase()}`;

    return `<div>
                <div></div>
                <div></div>
                <div></div>
                <div class ='Saleshandy-quoted'>
                <div>
                    ---------- Forwarded message ---------
                    <br />
                    From: <strong>${selectedEmail.senderName}</strong> &lt;${
      selectedEmail.fromEmail
    }&gt;
                    <br />
                    Date: ${formattedDate}
                    <br />
                    Subject: ${selectedEmail.subject}
                    <br />
                    To: &lt;${selectedEmail.to?.join(',')}&gt;
                    ${
                      selectedEmail.cc?.length &&
                      `<br />CC: &lt;${selectedEmail.cc.join(', ')}&gt;`
                    }
                </div>

                <div></div>
                ${selectedEmail.content}
                </div>
            </div>`;
  }

  return unifiedContent ?? '';
};
